var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoPlayComponents"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasAliyunId),expression:"hasAliyunId"}],staticClass:"prism-player",attrs:{"id":"Ailyun_prismPlayer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }